import React, {Component} from 'react'
import {
    FormGroup,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap'

import {
    AvForm,
    AvField,
} from 'availity-reactstrap-validation'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation} from 'react-apollo'
import PropTypes from 'prop-types'
import {toast} from 'react-toastify'

import upsertProjectNotesMutation from '../../../queries/server/mutations/upsert_project_notes'
import editProjectLocalMutation from '../../../queries/client_side/mutations/edit_project'

class ProjectContractStatusNoteCreateModal extends Component {

    state = {
        note: ''
    }

    render() {

        const {isOpen, toggle, project_id} = this.props
        const {note} = this.state

        return (
            <Mutation mutation={upsertProjectNotesMutation}>
                {(upsertProjectNotesMutationFunc, {loading}) => (
                    <Mutation mutation={editProjectLocalMutation}>
                        {(editProjectLocalMutationFunc) => (
                            <Modal isOpen={isOpen}>
                                <AvForm
                                    onValidSubmit={() => {
                                        upsertProjectNotesMutationFunc({variables: {project_id, data: [{note}]}})
                                            .then(({data}) => {
                                                editProjectLocalMutationFunc({variables: {data: data.upsertProjectNotes}})
                                                toast.success('Successfully Saved!', {autoClose: 2000})
                                                toggle()
                                            })
                                            .catch(e => {
                                                toast.error(e.message, {autoClose: false})
                                            })
                                    }}
                                >
                                    <ModalHeader toggle={toggle}>
                                        Contract Status Note
                                    </ModalHeader>
                                    <ModalBody>
                                        <FormGroup>
                                            <AvField
                                                required
                                                label="Note*"
                                                errorMessage="Required"
                                                type="textarea"
                                                name="name"
                                                id="name"
                                                bsSize="sm"
                                                value={note}
                                                onChange={(evt) => this.setState({note: evt.target.value})}
                                            />
                                        </FormGroup>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button size="sm" color="success" disabled={loading}>
                                            <FontAwesomeIcon
                                                color="#fff"
                                                icon={loading ? 'spinner' : 'save'}
                                                spin={loading}
                                            />{' '}
                                            {loading ? 'Saving...' : 'Save'}
                                        </Button>
                                    </ModalFooter>
                                </AvForm>
                            </Modal>
                        )}
                    </Mutation>
                )}

            </Mutation>
        )
    }

}

export default ProjectContractStatusNoteCreateModal

ProjectContractStatusNoteCreateModal.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    project_id: PropTypes.string.isRequired,
}